import { Call, CallState as SDKCallStatus, EnvironmentInfo } from "@azure/communication-calling";
import {
    CallClientState,
    CallState,
    DeviceManagerState,
    DiagnosticsCallFeatureState,
    LocalVideoStreamState,
} from "@azure/communication-react";
import { PcpLiveLessonState } from "../pcpLiveLessonStore.interface";


export const getCall = (state: PcpLiveLessonState): Call | undefined =>
    state.call;

export const getCallId = (state: PcpLiveLessonState): string | undefined =>
    state.call?.id;

export const getCallStatus = (state: PcpLiveLessonState): SDKCallStatus =>
    state.call?.state ?? 'None';

export const getCallClientState = (state: PcpLiveLessonState): CallClientState =>
    state.callClientState;

export const getCallState = (state: PcpLiveLessonState): CallState | undefined => {
    const callId = getCallId(state);
    return callId ? state.callClientState.calls[callId] : undefined;
};

export const getDeviceManager = (state: PcpLiveLessonState): DeviceManagerState =>
    state.callClientState.deviceManager;

export const getIsScreenShareOn = (state: PcpLiveLessonState): boolean =>
    getCallState(state)?.isScreenSharingOn ?? false;

export const getLocalVideoStreams = (state: PcpLiveLessonState): LocalVideoStreamState[] | undefined =>
    getCallState(state)?.localVideoStreams;

export const getUserFacingDiagnostics = (state: PcpLiveLessonState): DiagnosticsCallFeatureState | undefined =>
    getCallState(state)?.diagnostics;

export const getEnvironmentInfo = (state: PcpLiveLessonState): EnvironmentInfo | undefined =>
    state.callClientState.environmentInfo;
